import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import IconMap from 'client/icons/Map'
import Image from 'src/comps/Image'

import { PATH_IMAGES_CDN } from 'src/constants/environment'
import { MapBannerBase, ButtonViewMap } from './styles'
import messages from './messages'

const backgroundImage = `${PATH_IMAGES_CDN}/map-trigger.jpg`

const MapBanner = () => {
  const intl = useIntl()
  const imageAlt = intl.formatMessage(messages.mapView)

  return (
    <MapBannerBase>
      <Image src={backgroundImage} alt={imageAlt} layout="responsive" />

      <ButtonViewMap>
        <IconMap size={14} />
        <FormattedMessage {...messages.mapView} tagName="p" />
      </ButtonViewMap>
    </MapBannerBase>
  )
}

export default MapBanner
